$(document).ready(function () {
    const courseModal = $('.course-video-popup');
    const courseVideo = $('.video-wrapper video')[0];
    // Open Modal
    $('.watch-video-btn').click(function () {
        $('body').addClass('fixScreen');
        courseModal.addClass('show');
        // Play video from start
        if (courseVideo) {
            courseVideo.currentTime = 0;
            courseVideo.play().catch(err => {
                console.warn('Autoplay failed:', err);
            });
        }
    });
    // Close Modal by button
    $('.course-video-popup .dialog-close-btn').click(function () {
        closeModal();
    });
    // Close Modal by clicking outside
    $(document).mouseup(function (e) {
        const popupDialogBox = $('.course-video-popup .dialog-box');
        if (!courseModal.hasClass('show')) return;
        if (!popupDialogBox.is(e.target) && popupDialogBox.has(e.target).length === 0) {
            closeModal();
        }
    });

    // Close Modal Function
    function closeModal() {
        if (courseVideo) {
            courseVideo.pause();
            courseVideo.currentTime = 0;
        }
        courseModal.removeClass('show');
        $('body').removeClass('fixScreen');
    }
});
